import React, { useEffect, useState } from 'react';
import { Spin } from 'antd';
import './index.less';
import SeeAnalysis from '@/components/see-analysis';
import { IQuestionListItem, QuestionType } from '@/types';
import { getExamPointQuestionsAnalysis } from '@/apis';
import { subQuestionSortNumProjectIds } from '@/utils/config';
import globalStore from '@/store/global';
import { areKeysPresentAndNonEmpty } from '@/utils';

type InitProps = {
    knowledgePointId: number;
    projectId: number;
    subjectId: number;
    title?: string;
};

const Index: React.FC = props => {
    const [initInfo, setInitInfo] = useState<InitProps>();
    const [questionList, setQuestionList] = useState<IQuestionListItem[]>([]);
    const [questionOptions, setQuestionOptions] = useState<any>({});
    const [loading, setLoading] = useState(false);

    // 修改题目序号
    const changeSortNum = (list: IQuestionListItem[], isSubQuestionSortNum: boolean) => {
        let calSortNum = 0;
        return list.map((question, index) => {
            if (question.questionType === QuestionType.comprehensive) {
                const sortNum = isSubQuestionSortNum ? 0 : index + 1;

                return {
                    ...question,
                    subQuestionList: question.subQuestionList.map((subQuestion, sonIndex) => {
                        calSortNum += 1;
                        const sortNum = isSubQuestionSortNum ? calSortNum : `${index + 1}-${sonIndex + 1}`;

                        return {
                            ...subQuestion,
                            sortNum: sortNum,
                        };
                    }),
                    sortNum: sortNum,
                };
            }
            calSortNum += 1;
            const sortNum = isSubQuestionSortNum ? calSortNum : index + 1;
            return {
                ...question,
                sortNum: sortNum,
            };
        });
    };

    const fetchExamPointQuestionsAnalysis = async (params: InitProps) => {
        setLoading(true);
        const response = await getExamPointQuestionsAnalysis(params);
        if (response.status === 0) {
            const isSubQuestionSortNum = subQuestionSortNumProjectIds.includes(params!.projectId);
            const list = changeSortNum(response.result.questionList, isSubQuestionSortNum);
            setQuestionList(list);
        }
        setLoading(false);
    };

    useEffect(() => {
        globalStore.subscribe('CommonAnalysis', ({ type, params }) => {
            switch (type) {
                case 'init_exam_point':
                    if (areKeysPresentAndNonEmpty(params, ['knowledgePointId', 'projectId', 'subjectId'])) {
                        setInitInfo(params);
                        setQuestionOptions({ isPredictScore: true });
                        fetchExamPointQuestionsAnalysis(params);
                    } else {
                        console.error('Invalid params for CommonAnalysis');
                    }
                    break;
                default:
                    setInitInfo(undefined);
                    break;
            }
        });

        return () => {
            globalStore.unsubscribe('CommonAnalysis');
        };
    }, []);

    return (
        <div className="sub-tiku__see-analysis-container">
            {loading && <Spin className="see-analysis-spinning" />}
            {questionList.length > 0 && (
                <SeeAnalysis
                    questionIds={questionList.map(item => item.questionId)}
                    questionList={questionList}
                    projectId={initInfo!.projectId}
                    title={initInfo?.title || '全部解析'}
                    questionOptions={{ ...questionOptions }}
                />
            )}
        </div>
    );
};

export default Index;
